import { render, staticRenderFns } from "./answerSheet.vue?vue&type=template&id=5dded1e1&scoped=true"
import script from "./answerSheet.vue?vue&type=script&lang=js"
export * from "./answerSheet.vue?vue&type=script&lang=js"
import style0 from "./answerSheet.vue?vue&type=style&index=0&id=5dded1e1&lang=scss"
import style1 from "./answerSheet.vue?vue&type=style&index=1&id=5dded1e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dded1e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dded1e1')) {
      api.createRecord('5dded1e1', component.options)
    } else {
      api.reload('5dded1e1', component.options)
    }
    module.hot.accept("./answerSheet.vue?vue&type=template&id=5dded1e1&scoped=true", function () {
      api.rerender('5dded1e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/answerSheet.vue"
export default component.exports